import { BaseEntity } from '../../../core/models/base-entity.model';

export class FeedPostType extends BaseEntity<FeedPostType> {
  name = '';
  type = '';
}
